export const PreDiscountPriceInterval = 100;

export const PreDiscountPriceExampleImage = Object.freeze({
  ForPOD:
    'https://image1.marpple.co/files/u_2232571/2023/11/original/ea25e1425e3a5cd6e3da12039d7c2c88dace4a242.png?q=80&f=webp',
  ForNonPOD: '//s3.marpple.co/files/u_1514961/2025/9/original/27483e88b60eb38d38773660a11d8c3f51e213f51.png',
});
